import { Icons as e } from "../Icons/Icons.mjs";
import { Box as t } from "../Primitives/Box.mjs";
import { Flex as n } from "../Primitives/Flex.mjs";
import r from "react";
import { css as i, styled as a } from "styled-components";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/Alert/Alert.tsx
var c = (t) => {
	switch (t) {
		case "destructive": return /* @__PURE__ */ o(e.AlertCircle, { size: 18 });
		case "success": return /* @__PURE__ */ o(e.CheckCircle2, { size: 18 });
		case "warning": return /* @__PURE__ */ o(e.AlertTriangle, { size: 18 });
		case "info": return /* @__PURE__ */ o(e.Info, { size: 18 });
		default: return null;
	}
}, l = {
	default: i`
        background-color: ${({ theme: e }) => e.colors.secondary};
        border: 1px solid ${({ theme: e }) => e.colors.border};
        & svg {
            color: ${({ theme: e }) => e.colors.foreground};
        }
    `,
	success: i`
        background-color: ${({ theme: e }) => e.mode === "light" ? e.palette.tertiary.fixed : e.palette.tertiary.onFixed};
        border: 1px solid ${({ theme: e }) => e.colors.success};
        & svg {
            color: ${({ theme: e }) => e.colors.success};
        }
    `,
	destructive: i`
        background-color: ${({ theme: e }) => e.mode === "light" ? e.palette.error.container : e.palette.error.onContainer};
        border: 1px solid ${({ theme: e }) => e.colors.destructive};
        & svg {
            color: ${({ theme: e }) => e.colors.destructive};
        }
    `,
	warning: i`
        background-color: ${({ theme: e }) => e.mode === "light" ? "#fef9c3" : "#713f12"};
        border: 1px solid ${({ theme: e }) => e.colors.warning};
        & svg {
            color: ${({ theme: e }) => e.colors.warning};
        }
    `,
	info: i`
        background-color: ${({ theme: e }) => e.mode === "light" ? e.palette.primary.fixed : e.palette.primary.onFixed};
        border: 1px solid ${({ theme: e }) => e.colors.primary};
        & svg {
            color: ${({ theme: e }) => e.colors.primary};
        }
    `
}, u = {
	default: i`
        color: ${({ theme: e }) => e.colors.foreground};
    `,
	success: i`
        color: ${({ theme: e }) => e.mode === "light" ? e.palette.tertiary.onFixedVariant : e.palette.tertiary.fixedDim};
    `,
	destructive: i`
        color: ${({ theme: e }) => e.mode === "light" ? e.palette.error.onContainer : e.palette.error.container};
    `,
	warning: i`
        color: ${({ theme: e }) => e.mode === "light" ? "#854d0e" : "#fef08a"};
    `,
	info: i`
        color: ${({ theme: e }) => e.mode === "light" ? e.palette.primary.onFixedVariant : e.palette.primary.fixedDim};
    `
}, d = a(t)`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: ${({ theme: e }) => e.spacing(1, 2)};
    ${({ $variant: e }) => l[e]}
`, f = a.div`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    margin-bottom: ${({ theme: e }) => e.spacing(1)};
    ${({ $variant: e }) => u[e]}
`, p = a.div`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    ${({ $variant: e }) => u[e]}
    opacity: 0.9;
`, m = r.forwardRef(({ variant: e = "default", title: r, icon: i, children: a, ...l }, u) => {
	let m = i === void 0 ? c(e) : i;
	return /* @__PURE__ */ o(d, {
		ref: u,
		$variant: e,
		radius: "lg",
		...l,
		children: /* @__PURE__ */ s(n, {
			align: "flex-start",
			gap: 1,
			children: [m && /* @__PURE__ */ o("div", {
				style: { marginTop: r ? "2px" : "0" },
				children: m
			}), /* @__PURE__ */ s(t, {
				style: { flex: 1 },
				children: [r && /* @__PURE__ */ o(f, {
					$variant: e,
					children: r
				}), /* @__PURE__ */ o(p, {
					$variant: e,
					children: a
				})]
			})]
		})
	});
});
m.displayName = "Alert";
//#endregion
export { m as Alert };
